'use strict';

angular.module('administrationPortal').controller('AdminUsersSyncCtrl', ['$scope', '$location', '$adminUsersSyncService', '$adminUserDataService', '$adminUserService', function ($scope, $location, $adminUsersSyncService, $adminUserDataService, $adminUserService) {
  const self = this;

  self.user = $adminUserDataService.getUser();
  self.query = $adminUserDataService.getUsernameQuery();
  self.error = null;
  self.bucketState = null;
  self.operations = [];
  self.errors = [];
  self.findSyncDataByUsername = findSyncDataByUsername;
  self.getBucketState = getBucketState;

  init();

  function init() {
    const username = $location.search().username;
    if (username) {
      self.query = username;
      findSyncDataByUsername(username);
    } else if (self.query) {
      findSyncDataByUsername(self.query);
    }
  }

  function findSyncDataByUsername(username) {
    $adminUserDataService.setUsernameQuery(username);
    self.user = $adminUserDataService.getUser();
    self.bucketState = [];
    self.operations = [];
    self.errors = [];
    self.error = null;

    if (self.user && self.user.id) {
      getBucketState(self.user.id);
    } else {
      $adminUserService.getUser(username).$promise
        .then((user) => {
          $adminUserDataService.setUser(user);
          self.user = user;
          $location.search('username', username);

          getBucketState(self.user.id);
        })
        .catch((err) => {
          self.error = err.status === 404 ? 'User not found' : 'Server error: ' + err.data.message;
          self.user = null;
          $location.search('');
          $adminUserDataService.reset();
        });
    }
  }

  function getBucketState(userId) {
    $adminUsersSyncService.getBucketState(userId).$promise
      .then((bucketState) => {
        self.bucketState = bucketState;

        if (bucketState.hasOwnProperty('last_op') && bucketState.last_op !== null) {
          getBucketData(0, userId, bucketState.last_op);
        }
      })
      .catch((err) => {
        self.error = err.status === 404 ? 'User or sync bucket not found' : 'Server error: ' + err.data.message;
      });
  }

  function getBucketData(index, userId, operationId) {
    $adminUsersSyncService.getBucketData(userId, operationId).$promise
      .then((bucketData) => {
        if (bucketData.hasOwnProperty('data') && bucketData.data !== null && typeof bucketData.data === 'string') {
          bucketData.data = JSON.parse(bucketData.data);
        }
        self.operations[index] = bucketData;

        if (bucketData.hasOwnProperty('target_op') && bucketData.target_op !== null && index === 0) {
          getBucketData(index + 1, userId, bucketData.target_op);
        }
      })
      .catch((err) => {
        self.errors[index] = err.status === 404 ? 'Operation not found' : 'Server error: ' + err.data.message;
      });
  }
}]);
